import { faBars, faSearch, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import type { PrimaryButtonProps } from "../../../../components/navbar/components/primary-button/types";

export const icons: PrimaryButtonProps[] = [
    {
        icon: faSearch,
        url: "/produtos",
    },
    {
        icon: faShoppingCart,
    },
    {
        icon: faBars,
    },
];
